
<div>
  <b-button v-b-modal.modal-prevent-closing>{{ loginText }}</b-button>
  <b-modal id="modal-prevent-closing" ref="modal" title="Login to your bot" @ok="handleOk">
    <Login id="loginForm" ref="loginForm" in-modal @loginResult="handleLoginResult" />
  </b-modal>
</div>
